module.exports = __webpack_public_path__ + "img/摩羯座.f5f7bba7.svg";